/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AttributeType model module.
 * @module model/AttributeType
 * @version 1.0
 */
class AttributeType {
    /**
     * Constructs a new <code>AttributeType</code>.
     * @alias module:model/AttributeType
     */
    constructor() { 
        
        AttributeType.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AttributeType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AttributeType} obj Optional instance to populate.
     * @return {module:model/AttributeType} The populated <code>AttributeType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AttributeType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'String');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Class AttributeType
 * @member {Number} id
 */
AttributeType.prototype['id'] = undefined;

/**
 * Class AttributeType
 * @member {String} name
 */
AttributeType.prototype['name'] = undefined;

/**
 * Class AttributeType
 * @member {String} created_at
 */
AttributeType.prototype['created_at'] = undefined;

/**
 * Class AttributeType
 * @member {String} updated_at
 */
AttributeType.prototype['updated_at'] = undefined;






export default AttributeType;

